export const paymentTypes = [
    {
        value:'CASH',
        label_th:'เงินสด',
    },
    {
        value:'CREDIT',
        label_th:'บัตรเครดิต',
    },
]

export const convertPaymentType = (text) => {

    switch (text) {
        case 'CASH': return 'เงินสด'
        case 'CREDIT': return 'เครดิต'
        default: return 'NA'
    }
}

export const formatPhone = (text) => {
    return `${text.substr(0, 3)}-${text.substr(3, 3)}-${text.substr(6, 4)}`
}

export const convertGrade = (text) => {

    switch (text) {
        case 'K1': return 'อนุบาล 1'
        case 'K2': return 'อนุบาล 2'
        case 'K3': return 'อนุบาล 3'
        case 'P1': return 'ประถมศึกษาปีที่ 1'
        case 'P2': return 'ประถมศึกษาปีที่ 2'
        case 'P3': return 'ประถมศึกษาปีที่ 3'
        case 'P4': return 'ประถมศึกษาปีที่ 4'
        case 'P5': return 'ประถมศึกษาปีที่ 5'
        case 'P6': return 'ประถมศึกษาปีที่ 6'
        case 'S1': return 'มัธยมศึกษาปีที่ 1'
        case 'S2': return 'มัธยมศึกษาปีที่ 2'
        case 'S3': return 'มัธยมศึกษาปีที่ 3'
        case 'S4': return 'มัธยมศึกษาปีที่ 4'
        case 'S5': return 'มัธยมศึกษาปีที่ 5'
        case 'S6': return 'มัธยมศึกษาปีที่ 6'
        default: return 'บุคคลทั่วไป'
    }
}